// Shared by the test runner's key handlers (question_keys: Enter/arrows/?, checkbox: 1–9).
//
// True when a key press must be left to the browser: a held key (auto-repeat would
// race through questions), an IME composition, a Ctrl/Cmd/Alt chord (browser and OS
// shortcuts — Ctrl+1 switches tabs), or an open overlay. The image zoom, the report and
// feedback modals all lock the page with `body.overflow-hidden`; the question grid and
// the header menus are `dropdown` menus without `hidden`. Shift is allowed: `?` needs it,
// and some layouts type digits with Shift.
export function shortcutBlocked(event) {
  if (event.defaultPrevented || event.repeat || event.isComposing) return true
  if (event.ctrlKey || event.metaKey || event.altKey) return true
  if (document.body.classList.contains("overflow-hidden")) return true
  return document.querySelector('[data-dropdown-target="menu"]:not(.hidden)') !== null
}

// True when the key is content for the focused field (a free-text answer, a matching
// tile's select, any text input), not a shortcut. Checkboxes and radios are not: the
// answer options are checkboxes, and a Tab-focused one must not swallow the digits.
export function isTypingTarget(element) {
  if (!element || !element.tagName) return false
  if (element.isContentEditable) return true
  const tag = element.tagName
  if (tag === "TEXTAREA" || tag === "SELECT") return true
  return tag === "INPUT" && element.type !== "checkbox" && element.type !== "radio"
}
